import ProtocolSettingRepository from "@/repositories/vns/ProtocolSettingRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'protocolSettings',
    namespaced: true,
    state: makeState(),
    getters: makeGetters(),
    mutations: makeMutations(),
    actions: {
        async listOne ({ commit, state }, id) {
            commit('setLoading', true)
            await ProtocolSettingRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data.protocol)
            })
            commit('setLoading', false)
        },
        async listAll ({ commit }, params) {
            commit('setLoading', true)
            await ProtocolSettingRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data.protocols)
                if (response.data.data.meta && Object.keys(response.data.data.meta).length > 0){
                    commit('setPagination', response.data.data.meta)
                }
            })
            commit('setLoading', false)
        }
    }
}
